import { apiClient } from './api-client';
import { ApiResponse, Chapter, ListChaptersResponse } from '../types';

export const ChapterService = {
  /**
   * Get chapters by subject ID
   * @param subjectId The ID of the subject to get chapters for
   * @returns Promise that resolves to an array of Chapter objects
   */
  async getChaptersBySubjectId(subjectId: number): Promise<Chapter[]> {
    const response = await apiClient.get<ApiResponse<ListChaptersResponse>>(
      `/chapters/subject/${subjectId}`
    );
    return response.data.data.chapters;
  },

  /**
   * Get a chapter by ID
   * @param id The ID of the chapter to retrieve
   * @returns Promise that resolves to a Chapter object
   */
  async getChapterById(id: number): Promise<Chapter> {
    const response = await apiClient.get<ApiResponse<Chapter>>(`/chapters/${id}`);
    return response.data.data;
  },

  /**
   * Create a new chapter
   * @param chapterData The chapter data to create
   * @returns Promise that resolves to the created Chapter object
   */
  async createChapter(chapterData: { name: string, subject_id: number, display_order?: number }): Promise<Chapter> {
    const response = await apiClient.post<ApiResponse<Chapter>>('/chapters', chapterData);
    return response.data.data;
  },

  /**
   * Update an existing chapter
   * @param id The ID of the chapter to update
   * @param chapterData The chapter data to update
   * @returns Promise that resolves to the updated Chapter object
   */
  async updateChapter(id: number, chapterData: { name?: string, subject_id?: number, display_order?: number }): Promise<Chapter> {
    const response = await apiClient.put<ApiResponse<Chapter>>(`/chapters/${id}`, chapterData);
    return response.data.data;
  },

  /**
   * Delete a chapter
   * @param id The ID of the chapter to delete
   * @returns Promise that resolves when the chapter is deleted
   */
  async deleteChapter(id: number): Promise<void> {
    await apiClient.delete<ApiResponse<void>>(`/chapters/${id}`);
  }
};